export default __webpack_public_path__ + "static/media/info.e402e0eb.svg";